const config = {
    API_URL: 'http://localhost:8080',
};

export default config;


// const config = {
//     API_URL: process.env.REACT_APP_API_URL,
// };

// export default config;
